import { isMobile } from 'Utils/device';
import templateCompiler from './comments.tooltip.art';
import { 
  COMMENT_SHARP_MAP,
  COMMENT_TEXT_MARKUP_MAP,
  COMMENT_TYPEWRITER_MAP,
  FW_MOBILE_COMMENT_SELECT_COLOR_OR_CANCEL,
  COMMENT_SHARP_COLOR_MORE_TEAMS
} from "../constants/comments.tooltip.constants";
import { queryFromTeams } from '@/modules/queryData';

//template-container

let template1Map = {};
let template2Map = {};
if (isMobile) {
  template1Map = {...COMMENT_SHARP_MAP, more: null}
  template2Map = {...COMMENT_TEXT_MARKUP_MAP, more: null}
  console.log(template1Map)
} else {
  template1Map = {...COMMENT_SHARP_MAP}
  template2Map = {...COMMENT_TEXT_MARKUP_MAP}
}
// 非移动端、teams环境， 添加 more 按钮
if (queryFromTeams && !isMobile) {
  const TEAMS = [
    {
      name: COMMENT_SHARP_COLOR_MORE_TEAMS,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-more-color-teams'
    }
  ];
  COMMENT_SHARP_MAP.teams = TEAMS;
  COMMENT_TEXT_MARKUP_MAP.teams = TEAMS;
  COMMENT_TYPEWRITER_MAP.teams = TEAMS;
}

let template1 = templateCompiler(template1Map);
let template2 = templateCompiler(template2Map);
let template3 = templateCompiler(COMMENT_TYPEWRITER_MAP);
let template4 = templateCompiler(FW_MOBILE_COMMENT_SELECT_COLOR_OR_CANCEL);

export default function TooltipModule() {
    //let callbacks = bindCallbacks(CONVERT_LIST, callback);
    let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
    let fragments = [
      {
        // 向末尾追加控件
        action: ACTIONS.APPEND,
        // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
        target: 'template-container',
        // 定义控件的以及图标，文字等信息
        template: template1,
      },
      {
        action: ACTIONS.APPEND,
        target: 'template-container',
        template: template2,
      },
      {
        action: ACTIONS.APPEND,
        target: 'template-container',
        template: template3,
      },
      {
        action: ACTIONS.APPEND,
        target: 'template-container',
        template: template4,
      },
      //...callbacks,
    ];
    return {fragments};
}